import i18n from '@/i18n'

export default {
  purchaseList: [],
  purchaseInfo: {},
  unClosedPurchaseCount: 0,
  unPaidPurchaseCount: 0,
  paymentTypes: [{ text: i18n.t('Cash'), value: 'Cash' }, { text: i18n.t('On Account'), value: 'On Account' }]
}
